/* eslint-disable @ngrx/on-function-explicit-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Action, createReducer, on } from '@ngrx/store';
import {
    dashboardGetAllHotCandidates,
    dashboardGetAllHotCandidatesFail,
    dashboardGetAllHotCandidatesSuccess,
    dashboardGetAllLeadCandidates,
    dashboardGetAllLeadCandidatesFail,
    dashboardGetAllLeadCandidatesSuccess,
    dashboardGetAllLiveCandidates,
    dashboardGetAllLiveCandidatesFail,
    dashboardGetAllLiveCandidatesSuccess,
    dashboardGetAllPreCandidates,
    dashboardGetAllPreCandidatesFail,
    dashboardGetAllPreCandidatesSuccess,
    dashboardGetAllSelfApplyCandidates,
    dashboardGetAllSelfApplyCandidatesFail,
    dashboardGetAllSelfApplyCandidatesSuccess,
    dashboardGetAllWorCandidates,
    dashboardGetAllWorCandidatesFail,
    dashboardGetAllWorCandidatesSuccess,
    dashboardGetHotCandidates,
    dashboardGetHotCandidatesFail,
    dashboardGetHotCandidatesSuccess,
    dashboardGetHotDetails,
    dashboardGetHotDetailsFail,
    dashboardGetHotDetailsSuccess,
    dashboardGetJobInterest,
    dashboardGetJobInterestFail,
    dashboardGetJobInterestSuccess,
    dashboardGetLiveCandidates,
    dashboardGetLiveCandidatesFail,
    dashboardGetLiveCandidatesSuccess,
    dashboardGetLiveDetails,
    dashboardGetLiveDetailsFail,
    dashboardGetLiveDetailsSuccess,
    dashboardGetPendingHotCandidates,
    dashboardGetPendingHotCandidatesFail,
    dashboardGetPendingHotCandidatesSuccess,
    dashboardGetPreCandidates,
    dashboardGetPreCandidatesFail,
    dashboardGetPreCandidatesSuccess,
    dashboardGetPreDetails,
    dashboardGetPreDetailsFail,
    dashboardGetPreDetailsSuccess,
    dashboardGetSelfApplyCandidates,
    dashboardGetSelfApplyCandidatesFail,
    dashboardGetSelfApplyCandidatesSuccess,
    dashboardGetTileFollowups,
    dashboardGetTileFollowupsFail,
    dashboardGetTileFollowupsSuccess,
    dashboardGetWorCandidates,
    dashboardGetWorCandidatesFail,
    dashboardGetWorCandidatesSuccess,
    dashboardGetWorDetails,
    dashboardGetWorDetailsFail,
    dashboardGetWorDetailsSuccess,
    dashboardRemoveJobInterest,
    dashboardGetRecruiterLeadQueueStatus,
    dashboardGetRecruiterLeadQueueStatusFail,
    dashboardGetRecruiterLeadQueueStatusSuccess,
    showHideFlyout,
    showJobInterestDetailsFlyout,
    showJobInterestFlyout,
    startStopTimer,
    dashboardUpdateRecruiterLeadQueueStatus,
    dashboardUpdateRecruiterLeadQueueStatusSuccess,
    dashboardUpdateRecruiterLeadQueueStatusFail
} from './actions/dashboard.actions';
import { DashboardState } from './state/dashboard.state';

export const dashboardFeatureKey = 'dashboard';

export const initialState: DashboardState = {
    flyoutData: null,
    error: null,
    runTimer: true,
    hotItems: null,
    allHotItems: null,
    pendHotItems: null,
    hotDetail: null,
    liveItems: null,
    allLiveItems: null,
    liveDetail: null,
    preStartItems: null,
    allPreStartItems: null,
    preStartDetail: null,
    workingDetail: null,
    workingItems: null,
    allWorkingItems: null,
    jobInterestItems: null,
    jobInterestGroups: null,
    jobInterestGroup: null,
    jobInterestRemoveId: null,
    allLeadItems: null,
    tileFollowups: null,
    selfApplyCandidates: null,
    allSelfApplyCandidates: null,
    recruiterLeadInfoStatus: null
};

const dashboardReducer = createReducer(
    initialState,
    // Show or Hide a flyout
    on(showHideFlyout, (state, action) => ({
        ...state,
        flyoutData: action
    })),

    // Start or stop timed data fetches for all tiles
    on(startStopTimer, (state, action) => ({
        ...state,
        runTimer: action.runTimer
    })),

    // initiate hot candidate fetch
    on(dashboardGetHotCandidates, (state, action) => ({
        ...state,
        hotItems: null
    })),

    // hot candidates fetched
    on(dashboardGetHotCandidatesSuccess, (state, action) => ({
        ...state,
        hotItems: action.hots
    })),

    // hot candidate fetch failure
    on(dashboardGetHotCandidatesFail, (state, action) => ({
        ...state,
        error: action.error
    })),

    // initiate all hot candidate fetch
    on(dashboardGetAllHotCandidates, (state, action) => ({
        ...state,
        allHotItems: null
    })),

    // all hot candidates fetched
    on(dashboardGetAllHotCandidatesSuccess, (state, action) => ({
        ...state,
        allHotItems: action.hots
    })),

    // all hot candidate fetch failure
    on(dashboardGetAllHotCandidatesFail, (state, action) => ({
        ...state,
        error: action.error
    })),

    // initiate pending candidate fetch
    on(dashboardGetPendingHotCandidates, (state, action) => ({
        ...state,
        hotItems: null
    })),

    // pending hot candidates fetched
    on(dashboardGetPendingHotCandidatesSuccess, (state, action) => ({
        ...state,
        pendHotItems: action.hots
    })),

    // pending hot candidate fetch failure
    on(dashboardGetPendingHotCandidatesFail, (state, action) => ({
        ...state,
        error: action.error
    })),

    // initiate hot details fetch
    on(dashboardGetHotDetails, (state, action) => ({
        ...state,
        hotDetail: null
    })),

    // hot details fetched
    on(dashboardGetHotDetailsSuccess, (state, action) => ({
        ...state,
        hotDetail: action.hotDetail
    })),

    // hot details fetch failure
    on(dashboardGetHotDetailsFail, (state, action) => ({
        ...state,
        error: action.error
    })),

    // initiate live candidate fetch
    on(dashboardGetLiveCandidates, (state, action) => ({
        ...state,
        liveItems: null
    })),

    // live candidates fetched
    on(dashboardGetLiveCandidatesSuccess, (state, action) => ({
        ...state,
        liveItems: action.lives
    })),

    // live candidate fetch failure
    on(dashboardGetLiveCandidatesFail, (state, action) => ({
        ...state,
        error: action.error
    })),

    // initiate all live candidate fetch
    on(dashboardGetAllLiveCandidates, (state, action) => ({
        ...state,
        allLiveItems: null
    })),

    // all live candidates fetched
    on(dashboardGetAllLiveCandidatesSuccess, (state, action) => ({
        ...state,
        allLiveItems: action.lives
    })),

    // live candidate fetch failure
    on(dashboardGetAllLiveCandidatesFail, (state, action) => ({
        ...state,
        error: action.error
    })),

    // initiate live details fetch
    on(dashboardGetLiveDetails, (state, action) => ({
        ...state,
        liveDetail: null
    })),

    // live details fetched
    on(dashboardGetLiveDetailsSuccess, (state, action) => ({
        ...state,
        liveDetail: action.details
    })),

    // live details fetch failure
    on(dashboardGetLiveDetailsFail, (state, action) => ({
        ...state,
        error: action.error
    })),

    // initiate prestart candidate fetch
    on(dashboardGetPreCandidates, (state, action) => ({
        ...state,
        preStartItems: null
    })),

    // prestart candidates fetched
    on(dashboardGetPreCandidatesSuccess, (state, action) => ({
        ...state,
        preStartItems: action.items
    })),

    // prestart candidate fetch failure
    on(dashboardGetPreCandidatesFail, (state, action) => ({
        ...state,
        error: action.error
    })),

    // initiate all prestart candidate fetch
    on(dashboardGetAllPreCandidates, (state, action) => ({
        ...state,
        allPreStartItems: null
    })),

    // all prestart candidates fetched
    on(dashboardGetAllPreCandidatesSuccess, (state, action) => ({
        ...state,
        allPreStartItems: action.data
    })),

    // all prestart candidates fetch failure
    on(dashboardGetAllPreCandidatesFail, (state, action) => ({
        ...state,
        error: action.error
    })),

    // initiate prestart details fetch
    on(dashboardGetPreDetails, (state, action) => ({
        ...state,
        preStartDetail: null
    })),

    // prestart details fetched
    on(dashboardGetPreDetailsSuccess, (state, action) => ({
        ...state,
        preStartDetail: action.data
    })),

    // all prestart candidates fetch failure
    on(dashboardGetPreDetailsFail, (state, action) => ({
        ...state,
        error: action.error
    })),

    // initiate working candidate fetch
    on(dashboardGetWorCandidates, (state, action) => ({
        ...state,
        workingItems: null
    })),

    // working candidates fetched
    on(dashboardGetWorCandidatesSuccess, (state, action) => ({
        ...state,
        workingItems: action.items
    })),

    // working candidates fetch failure
    on(dashboardGetWorCandidatesFail, (state, action) => ({
        ...state,
        error: action.error
    })),

    // initiate all working candidate fetch
    on(dashboardGetAllWorCandidates, (state, action) => ({
        ...state,
        allWorkingItems: null
    })),

    // all working candidates fetched
    on(dashboardGetAllWorCandidatesSuccess, (state, action) => ({
        ...state,
        allWorkingItems: action.data
    })),

    // all working candidates fetch failure
    on(dashboardGetAllWorCandidatesFail, (state, action) => ({
        ...state,
        error: action.error
    })),

    // initiate working details fetch
    on(dashboardGetWorDetails, (state, action) => ({
        ...state,
        workingDetail: null
    })),

    // working details fetched
    on(dashboardGetWorDetailsSuccess, (state, action) => ({
        ...state,
        workingDetail: action.data
    })),

    // working detail fetch failure
    on(dashboardGetWorDetailsFail, (state, action) => ({
        ...state,
        error: action.error
    })),

    // initiate job interest fetch
    on(dashboardGetJobInterest, (state, action) => ({
        ...state,
        jobInterestItems: null
    })),

    // job interest count fetched
    on(dashboardGetJobInterestSuccess, (state, action) => ({
        ...state,
        jobInterestItems: action.data
    })),

    // working detail fetch failure
    on(dashboardGetJobInterestFail, (state, action) => ({
        ...state,
        error: action.error
    })),

    // initiate all live candidate fetch
    on(dashboardGetAllLeadCandidates, (state, action) => ({
        ...state,
        allLeadItems: null
    })),

    // all live candidates fetched
    on(dashboardGetAllLeadCandidatesSuccess, (state, action) => ({
        ...state,
        allLeadItems: action.leads
    })),

    // live candidate fetch failure
    on(dashboardGetAllLeadCandidatesFail, (state, action) => ({
        ...state,
        error: action.error
    })),

    // Show data for job interest flyout
    on(showJobInterestFlyout, (state, action) => ({
        ...state,
        jobInterestGroups: action.data
    })),

    // Show data for job interest details flyout
    on(showJobInterestDetailsFlyout, (state, action) => ({
        ...state,
        jobInterestGroup: action.data
    })),

    // Refresh data for job interest details flyout
    on(dashboardRemoveJobInterest, (state, action) => ({
        ...state,
        jobInterestRemoveId: action.data
    })),

    // initiate followup tile fetch
    on(dashboardGetTileFollowups, (state, action) => ({
        ...state,
        tileFollowups: null
    })),

    // tile followups fetched
    on(dashboardGetTileFollowupsSuccess, (state, action) => ({
        ...state,
        tileFollowups: action.data
    })),

    // tile followups fetch failure
    on(dashboardGetTileFollowupsFail, (state, action) => ({
        ...state,
        error: action.error
    })),

    // initiate Self Apply candidate fetch
    on(dashboardGetSelfApplyCandidates, (state, action) => ({
        ...state,
        selfApplyCandidates: null
    })),

    // Self Apply Candidates fetched
    on(dashboardGetSelfApplyCandidatesSuccess, (state, action) => ({
        ...state,
        selfApplyCandidates: action.selfApplyCandidates
    })),

    // Self Apply candidate fetch failure
    on(dashboardGetSelfApplyCandidatesFail, (state, action) => ({
        ...state,
        error: action.error
    })),

    // initiate ALL Self Apply candidate fetch
    on(dashboardGetAllSelfApplyCandidates, (state, action) => ({
        ...state,
        allSelfApplyCandidates: null
    })),

    // All Self Apply fetched
    on(dashboardGetAllSelfApplyCandidatesSuccess, (state, action) => ({
        ...state,
        allSelfApplyCandidates: action.selfApplyCandidates
    })),

    // All live Self Apply candidate fetch failure
    on(dashboardGetAllSelfApplyCandidatesFail, (state, action) => ({
        ...state,
        error: action.error
    })),

    // initiate lead queue status fetch
    on(dashboardGetRecruiterLeadQueueStatus, (state, action) => ({
        ...state,
        recruiterId: null
    })),

    // lead queue status fetched
    on(dashboardGetRecruiterLeadQueueStatusSuccess, (state, action) => ({
        ...state,
        recruiterLeadInfoStatus: action.recruiterLeadInfoStatus
    })),

    // lead queue status fetch failure
    on(dashboardGetRecruiterLeadQueueStatusFail, (state, action) => ({
        ...state,
        error: action.error
    })),

    // toggle lead queue status
    on(dashboardUpdateRecruiterLeadQueueStatus, (state, action) => ({
        ...state,
        recruiterId: action.leadInfoId
    })),

    // toggle lead queue status succeed
    on(dashboardUpdateRecruiterLeadQueueStatusSuccess, (state, action) => ({
        ...state,
        recruiterLeadInfoStatus: action.recruiterLeadInfoStatus
    })),

    // toggle lead queue status failure
    on(dashboardUpdateRecruiterLeadQueueStatusFail, (state, action) => ({
        ...state,
        error: action.error
    }))
);

export function reducer(state: DashboardState | undefined, action: Action) {
    return dashboardReducer(state, action);
}
